var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.brand === 'BT')?_c('ubett'):_c('wbetnew')}
var staticRenderFns = []

export { render, staticRenderFns }